
import React from "react";
import _ from "lodash";
import { IKImage } from "imagekitio-react";

import { TableCellText } from "./TableCellText";
import styles from "./common.module.scss";

const DEFAULT_ASSET_ICON = "/images/defaultIcons/default_asset.jpg";

const getField = (mapping: any, key: string) => {
  const fields = _.get(mapping, "fields") || [];
  return _.get(
    fields.find((f: any) => f.name === key),
    "content",
    "",
  );
};

interface AssetNameCellProps {
  asset: any;
}

export const AssetNameCell: React.FC<AssetNameCellProps> = ({ asset }) => {
  const name = getField(asset, "name") || "";
  const type = getField(asset, "contentType");
  const size = getField(asset, "fileSize");
  const iconPath = _.get(getField(asset, "icon"), "url");
  const formatLabel = [type, size].filter(Boolean).join(" | ");

  return (
    <div className={styles.assetCell}>
      {iconPath ? (
        <IKImage
          className={styles.assetThumbnail}
          path={iconPath}
          transformation={[{ width: "120", quality: "85", format: "webp" }]}
          alt={name}
        />
      ) : (
        <img className={styles.assetThumbnail} src={DEFAULT_ASSET_ICON} alt={name} />
      )}
      <div className={styles.assetDetails}>
        <TableCellText className={styles.assetName} text={name} />
        {formatLabel && <TableCellText className={styles.assetFormat} text={formatLabel} />}
      </div>
    </div>
  );
};
